import script from "./SoilMap.vue?vue&type=script&setup=true&lang=js"
export * from "./SoilMap.vue?vue&type=script&setup=true&lang=js"

import "./SoilMap.vue?vue&type=style&index=0&id=ca4963a8&lang=css"

const __exports__ = script;

export default __exports__